<template>
    <div class="main">
        <c-panel>
            <fluxos></fluxos>
        </c-panel>
    </div>
</template>
<script>

import fluxos from "./fluxos"

export default {
    components:{ fluxos }
}
</script>
